import { AxiosError } from "axios";
import { createContext } from "react";

import { ClientFiltersResponse } from "@/types/response/ClientFiltersResponse";
import { GetClientResponse } from "@/types/response/GetClientResponse";
import { GetClientsResponse } from "@/types/response/GetClientsResponse";

export type ClientContextType = {
    filters: ClientFiltersResponse | undefined
    filtersFetching: boolean
    filtersLoading: boolean

    client: GetClientResponse | undefined;
    clientError: AxiosError | null;
    clientFetching: boolean;
    clientLoading: boolean;
    clients: GetClientsResponse | undefined;
    isFetching: boolean;
    isLoading: boolean;
}

export const ClientContext = createContext<ClientContextType | undefined>(undefined);
